import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import CategoriesManager from "./views/CategoriesManager.vue";

Vue.use(Router);

export default new Router(
  {
    mode: 'history',
    routes: [
      {
        path: "/",
        name: "home",
        component: Home,
      },
      {
        path: "/en",
        name: "home_en",
        component: Home,
        props: {
          lang: "en"
        }
      },
      {
        path: "/categ",
        name: "categ",
        component: CategoriesManager,
      },
    ],
  }
);
